// @flow
import React from 'react';

import Input from '../Input';
import type { Props as InputProps } from '../Input';

export type Props = InputProps;

export default (props: Props) => <Input type="text" {...props} />;



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/TextInput/TextInput.jsx